/**
 * Project : workspace
 * File    : LocationsFeature.js.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package native.locations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue

import dev.jordond.compass.Priority
import dev.jordond.compass.geocoder.NotSupportedPlatformGeocoder
import dev.jordond.compass.geocoder.PlatformGeocoder
import dev.jordond.compass.geolocation.Geolocator
import dev.jordond.compass.geolocation.LocationRequest
import dev.jordond.compass.geolocation.Locator
import dev.jordond.compass.geolocation.NotSupportedLocator
import dev.jordond.compass.geolocation.browser.api.Geolocation
import dev.jordond.compass.geolocation.browser.api.model.createGeolocationOptions
import dev.jordond.compass.geolocation.browser.internal.Object
import dev.jordond.compass.tools.web.HttpApiEndpoint

actual class LocationsFeature {
    actual companion object {
        actual var instance: LocationsFeature? = null
        actual fun shared(): LocationsFeature {
            return if (instance != null) {
                instance as LocationsFeature
            } else {
                instance = LocationsFeature()
                instance as LocationsFeature
            }
        }
    }

    actual var requestPermission: () -> Unit = {}
    actual var onCaptureLocation: (lat: Double, long: Double) -> Unit = {_,_->}
    actual var onPermissionChange: (Boolean) -> Unit = {}

    @Composable
    actual fun content() {

    }
    actual fun getPlatformGeocoder(): PlatformGeocoder {
        return getPlatformGeocoderOrFallback("AIzaSyDLLTAizy6tBMaq_1V9adjqCcTukKyWSp8")
    }

    actual fun getPlatformGeocoderOrFallback(apiKey: String): PlatformGeocoder {
        return NotSupportedPlatformGeocoder
//        return GoogleMapsPlatformGeocoder(
//            apiKey = apiKey,
//            client = HttpApiEndpoint.httpClient(enableLogging = true)
//        ) {
//            locationType(GoogleMapsLocationType.Approximate)
//        }
    }

    actual fun getPlatformLocator(): Locator {
        return NotSupportedLocator
    }

    actual val canShowAppSettings: Boolean = false

    actual fun showAppSettings() {
        // No-op
    }

    actual fun captureLocation(callBack: (lat: Double, long: Double) -> Unit) {
        Geolocation().getCurrentPosition(
            success = { position ->

            },
            error = {  },
            options = LocationRequest(priority = Priority.HighAccuracy).toOptions()
        )
    }

    private fun LocationRequest.toOptions(): Object {
        return createGeolocationOptions(
            enableHighAccuracy = priority == Priority.HighAccuracy,
            maximumAge = maximumAge.toDouble(),
            timeout = Double.POSITIVE_INFINITY,
        )
    }
}